import React from 'react';
import { COMPANY_INFO } from '../data/siteData';

export default function FloatingCTA() {
  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-40 flex flex-col items-center gap-3 print:hidden pointer-events-auto"
    >
      {/* Email button */}
      <a
        href={`mailto:${COMPANY_INFO.email}`}
        aria-label={`Send e-mail til ${COMPANY_INFO.email}`}
        title={`Send e-mail til ${COMPANY_INFO.email}`}
        className="group relative flex items-center justify-center w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-white text-[#1b4332] border-2 border-[#1b4332]/20 shadow-lg hover:shadow-xl hover:border-[#1b4332] hover:bg-[#f2f7f4] hover:scale-105 active:scale-95 transition-all duration-200"
      >
        <i
          className="fa-solid fa-envelope text-lg sm:text-xl text-[#1b4332] transition-transform duration-200 group-hover:scale-110"
          aria-hidden="true"
        />
        {/* Tooltip on desktop */}
        <span className="hidden sm:block pointer-events-none absolute right-full mr-3 px-2.5 py-1 rounded-md bg-[#163627] text-white text-xs font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-md">
          Send e-mail
        </span>
      </a>

      {/* Phone button */}
      <a
        href={`tel:${COMPANY_INFO.phoneRaw}`}
        aria-label={`Ring til ${COMPANY_INFO.phone}`}
        title={`Ring til ${COMPANY_INFO.phone}`}
        className="group relative flex items-center justify-center w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-[#1b4332] text-white shadow-lg hover:shadow-xl hover:bg-[#143627] hover:scale-105 active:scale-95 transition-all duration-200 border-2 border-[#2d6a4f]/50"
      >
        <i
          className="fa-solid fa-phone text-lg sm:text-xl text-white transition-transform duration-200 group-hover:scale-110"
          aria-hidden="true"
        />
        {/* Tooltip on desktop */}
        <span className="hidden sm:block pointer-events-none absolute right-full mr-3 px-2.5 py-1 rounded-md bg-[#163627] text-white text-xs font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-md">
          Ring {COMPANY_INFO.phone}
        </span>
      </a>
    </aside>
  );
}
